import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown, DropdownContent, type IDropdownProps, type IIconButtonProps } from 'shared/ui'
import { type DeviceSettingsStore } from 'entities/DeviceSettings/store'
import {
  DeviceSettingsContent,
  type IDeviceSettingsContentProps,
} from 'entities/DeviceSettings/ui/DeviceSettingsContent/DeviceSettingsContent'
import styles from './styles.module.scss'

type IDeviceSettingsProps = {
  deviceSettingsStore: DeviceSettingsStore
  dropdownProps: IDropdownProps
  variantDropdownBtn?: IIconButtonProps['variant']
  testOutputDevice?: () => void
  iconButtonProps?: Omit<IIconButtonProps, 'ariaLabel'> & { ariaLabel?: string }
  exclude?: IDeviceSettingsContentProps['exclude']
}

export const DeviceSettings: FC<IDeviceSettingsProps> = observer(
  ({
    iconButtonProps,
    deviceSettingsStore,
    dropdownProps,
    variantDropdownBtn,
    testOutputDevice,
    exclude,
  }) => {
    return (
      <div className={styles.wrap}>
        <Dropdown
          iconButtonProps={{
            icon: 'settings2',
            size: 'medium',
            variant: variantDropdownBtn,
            ariaLabel: 'DeviceSettings_actionButton',
            ...iconButtonProps,
          }}
          tooltipProps={{
            label: 'Settings',
            placement: 'top',
          }}
          customComponent={(onClose, dropdownId) => (
            <DropdownContent>
              <DeviceSettingsContent
                parentsDropdownId={[dropdownId]}
                deviceSettingsStore={deviceSettingsStore}
                testOutputDevice={testOutputDevice}
                exclude={exclude}
              />
            </DropdownContent>
          )}
          {...dropdownProps}
        />
      </div>
    )
  }
)
